import { firestore } from '@/firebase'
import profiles from './profiles'
import companies from './companies'
import products from './products'
import stores from './stores'
import auth from './auth'
import files from './files'

function transform (doc) {
  const data = doc.data()
  data._key = doc.id
  data._ref = doc.ref.path
  return data
}
function subscribe (ref, callbacks, success, error) {
  if (!ref || !ref.onSnapshot) return null
  return ref.onSnapshot((snapshot) => {
    if ('docChanges' in snapshot && 'forEach' in snapshot.docChanges) {
      if (callbacks) {
        if (callbacks.before) callbacks.before(snapshot)
        snapshot.docChanges.forEach((change) => {
          const doc = transform(change.doc)
          if (change.type === 'added') {
            if (callbacks.added) callbacks.added(doc)
          }
          if (change.type === 'modified') {
            if (callbacks.modified) callbacks.modified(doc)
          }
          if (change.type === 'removed') {
            if (callbacks.removed) callbacks.removed(doc)
          }
        })
        if (callbacks.after) callbacks.after(snapshot)
      }
    } else if (callbacks && 'updated' in callbacks) {
      callbacks.updated(transform(snapshot))
    }
  }, (err) => {
    if (error) error(err)
  }, () => {
    if (success) success()
  })
}

function get (ref, success, error) {
  return ref ? ref
    .get()
    .then((doc) => {
      let res
      if ('forEach' in doc) {
        res = []
        doc.forEach((d) => {
          res.push(transform(d))
        })
      } else {
        res = transform(doc)
      }
      if (success) success(res)
    })
    .catch((err) => {
      if (error) error(err)
    }) : null
}

function authSubscribe (ref, callbacks, success, error) {
  let unsubscribe = null
  auth.changed((user) => {
    if (unsubscribe) unsubscribe()
    unsubscribe = subscribe(ref(user), callbacks, success, error)
  })
  return () => {
    if (unsubscribe) unsubscribe()
  }
}

function add (ref, val, success, error) {
  return ref
    .add(val)
    .then((doc) => { if (success) success(doc) })
    .catch((err) => { if (error) error(err) })
}

function update (ref, fields, success, error) {
  return ref
    .update(fields)
    .then((doc) => { if (success) success(doc) })
    .catch((err) => { if (error) error(err) })
}

function sendFeedback (feedback, success, error) {
  return firestore.collection('feedback').add({feedback})
    .then((ref) => {
      if (success) success(ref)
    })
    .catch((err) => {
      if (error) error(err)
    })
}

function getMyNotifications (callbacks, success, error) {
  return authSubscribe(user => firestore
    .collection('users')
    .doc(user.uid)
    .collection('notifications'), callbacks, success, error)
}

function getMyMessages (callbacks, success, error) {
  return authSubscribe(user => firestore
    .collection('users')
    .doc(user.uid)
    .collection('inbox'), callbacks, success, error)
}

export default {
  companies,
  auth,
  files,
  profiles,
  products,
  stores,
  subscribe,
  authSubscribe,
  get,
  add,
  update,
  sendFeedback,
  getMyMessages,
  getMyNotifications
}



// WEBPACK FOOTER //
// ./src/api/index.js